export enum PaymentTranslKey {
    ACCOUNT_NUMBER = "payment:accountNumber",
    AMOUNT = "payment:amount",
    DOWNLOAD_PAYMENT_INFORMATION_PDF = "payment:downloadPaymentInformationPdf",
    MESSAGE_FOR_RECIPIENT = "payment:messageForRecipient",
    PAYMENT_INFORMATION = "payment:paymentInformation",
    PAYMENT_INFORMATION_ERROR = "payment:paymentInformationError",
    PAYMENT_INFORMATION_FILE_NAME = "payment:paymentInformationFileName",
    PAYMENT_INFORMATION_LOADING = "payment:paymentInformationLoading",
    PAYMENT_INFORMATION_TITLE = "payment:paymentInformationTitle",
    SPECIFIC_SYMBOL = "payment:specificSymbol",
    VARIABLE_SYMBOL = "payment:variableSymbol"
}
